import Analytics from '@/services/Analytics';
import { RegistrationStateNames as R } from '../hooks/useRegistration';

/**
 * Segment event for the post-purchase steps (BIO-2153), with the props every
 * one of them carries: who, which level and which plan at which amount.
 */
const postPurchaseTrack = (state, event, props = {}) => {
  const plan = state[R.SUPERVISION_PLAN] || {};

  Analytics.track(event, {
    companyId: state[R.COMPANY_ID],
    tierNumber: state[R.TIER_NUMBER],
    level: state[R.SUPERVISION_LEVEL],
    productKey: plan.productKey,
    planValue: plan.value,
    monthlyAmount: plan.monthlyPrice,
    band: plan.employeeSizeMapping,
    source: 'get',
    ...props,
  });
};

export default postPurchaseTrack;
